import Vue from 'vue'
import Category from '../models/Shop/Category'
import Product from '../models/Shop/Product'

export const state = () => ({
  categories: [],
  nested_categories: [],
  category: {
    lowest_price: 0,
    highest_price: 800
  },
  category_products: null
})

export const getters = {
  categories: (state) => {
    return state.categories
  },
  getCategory: (state) => {
    return state.category
  },
  nestedCategories: (state) => {
    return state.nested_categories
  },
  getCategoryById: state => (id) => {
    return state.categories.find(category => category.id === id)
  },
  getCategoryBySlug: state => (slug) => {
    return state.categories.find(category => category.slug === slug)
  },
  getCategoryProducts: (state) => {
    return state.category_products
  }
}

export const mutations = {
  setCategories (state, categories) {
    state.categories = categories
  },
  resetCategoryProducts: (state) => {
    state.categoryProducts = []
  },
  setCategory (state, category) {
    state.category = category
  },
  setNestedCategories (state, categories) {
    state.nested_categories = categories
  },
  setCategoryProducts: (state, payload) => {
    state.category_products = payload
  }
}

export const actions = {
  async fetchCategories ({}, payload) {
    try {
      const categories = Category.include('media')

      if (payload) {
        if (Object.prototype.hasOwnProperty.call(payload, 'root')) {
          categories.where('rootItem', payload.root)
        }
      }
      const result = await categories.get()
      return result.data
    } catch (err) {
      if (process.client) {
        Vue.notify({
          group: 'general',
          type: 'error',
          text: this.app.i18n.t('not_found')
        })
      }
    }
  },
  async fetchNestedCategories ({ commit }) {
    try {
      const result = await this.$axios.get('/categories?type=nested')
      commit('setNestedCategories', result.data)
      return result.data
    } catch (err) {
      if (process.client) {
        Vue.notify({
          group: 'general',
          type: 'error',
          text: this.app.i18n.t('not_found')
        })
      }
    }
  },
  async fetchPopularCategories ({ commit }) {
    try {
      const popular_categories = await Category
        .custom('categories/popular')
        .get()
      return popular_categories.data
    } catch (err) {
      if (process.client) {
        Vue.notify({
          group: 'general',
          type: 'error',
          text: this.app.i18n.t('not_found')
        })
      }
    }
  },
  async fetchCategory ({ commit }, slug) {
    const result = await Category
      .include('productsParameters', 'productsParameters.parameter', 'children', 'parent', 'products', 'media')
      .append('highest_price', 'lowest_price', 'parameters')
      .find(slug)
    commit('setCategory', result)
    return result
  },
  async fetchCategoryProducts ({ commit }, payload) {
    try {
      const products = Product
        .where('category_id', state.category.data.id)
      if (payload.filters) {
        if (payload.filters.price_between) {
          products.where('price_between', payload.filters.price_between)
        }
      }
      if (payload.sort) {
        products.orderBy(payload.sort)
      }
      if (payload.page) {
        products.page(payload.page)
      }
      const result = await products.get()
      commit('setCategoryProducts', result)
    } catch (err) {
      if (process.client) {
        Vue.notify({
          group: 'general',
          type: 'error',
          text: this.app.i18n.t('not_found')
        })
      }
    }
  },
  resetCategoryProducts ({ commit }) {
    commit('resetCategoryProducts')
  }
}
